module.exports = __webpack_public_path__ + "static/media/Recipe.1c39696f.png";